import { render } from "./LinkedCardsTab.vue?vue&type=template&id=26db3d5d&scoped=true"
import script from "./LinkedCardsTab.vue?vue&type=script&lang=js"
export * from "./LinkedCardsTab.vue?vue&type=script&lang=js"

import "./LinkedCardsTab.vue?vue&type=style&index=0&id=26db3d5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26db3d5d"

export default script